export default function App() {
  return (
    <>
      <h1>Iconduit</h1>
    </>
  );
}
